export default __webpack_public_path__ + "static/media/keto_skipped_breakfast@2x.029423ff.jpg";